import { render } from "./RegionForm.vue?vue&type=template&id=24b73c90&scoped=true&ts=true"
import script from "./RegionForm.ts?vue&type=script&lang=ts"
export * from "./RegionForm.ts?vue&type=script&lang=ts"

import "./RegionForm.scss?vue&type=style&index=0&id=24b73c90&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b73c90"]])

export default __exports__